<template>
    <div>
        <h1>Clear System</h1>
    </div>
</template>
<script>
    export default{
        mounted(){
            setTimeout(() => {
                this.$router.push('/login')
            }, 3000);
            this.CHANGE_API_LINK('https://1ze9v428i9.execute-api.us-east-2.amazonaws.com/prod/') 
            this.CHANGE_USER_DATA({})
            
            // alert(this.aws)
        }
    }
</script>